import NavSideBar from "../component/NavSideBar";

export default function BlankPage() {
  return (
    <NavSideBar>
        <div className="p-10 text-3xl font-bold">BlankPage</div>
    </NavSideBar>
  )
}
